const ProductUse = () => {
    return (<h2>ProductUse</h2>)
}

export default ProductUse